export default {
    omdbKey: "85d27bd7",
    emailJSKey: 'jtXePgxZCRdFCVyVE'
}